// src/components/services/IntercomService.js

/**
 * Updates Intercom with the latest user data
 * @param {Object} user - The user object
 */
export const updateIntercomUser = (user) => {
    if (typeof window !== 'undefined' && window.Intercom && user) {
      window.Intercom('update', {
        user_id: user.uid,
        name: user.displayName || user.email?.split('@')[0] || '',
        email: user.email || '',
        // Add custom attributes
        isPro: user.isPro || false,
        lastActive: new Date().toISOString(),
        // IMPORTANTE: Mantener el launcher oculto incluso al actualizar
        hide_default_launcher: true
      });
    }
  };
  
  /**
   * Tracks an event in Intercom
   * @param {string} eventName - The name of the event
   * @param {Object} metadata - Additional data about the event
   */
  export const trackIntercomEvent = (eventName, metadata = {}) => {
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('trackEvent', eventName, metadata);
    }
  };
  
  /**
   * Shows the Intercom messenger
   */
  export const showIntercom = () => {
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('show');
    }
  };
  
  /**
   * Hides the Intercom messenger
   */
  export const hideIntercom = () => {
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('hide');
    }
  };
  
  /**
   * Shuts down the Intercom instance
   */
  export const shutdownIntercom = () => {
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('shutdown');
    }
  };
  
  /**
   * Updates the Intercom theme based on the app's theme mode
   * @param {boolean} isDarkMode - Whether the app is in dark mode
   */
  export const updateIntercomTheme = (isDarkMode) => {
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('update', {
        // Actualizar atributo de tema
        theme: isDarkMode ? 'dark' : 'light'
      });
    }
  };
  
  /**
   * Identifies user segment and updates Intercom with advanced user attributes
   * @param {Object} user - The user object
   */
  export const identifyUserSegment = (user) => {
    if (!user || typeof window === 'undefined' || !window.Intercom) return;
    
    // Determinar segmento de usuario
    const userSegment = user.isPro ? 'pro' : 'free';
    const userAge = user.metadata?.creationTime 
      ? Math.floor((Date.now() - new Date(user.metadata.creationTime).getTime()) / (1000 * 60 * 60 * 24))
      : 0;
    
    // Actualizar con atributos avanzados
    window.Intercom('update', {
      user_id: user.uid,
      user_segment: userSegment,
      account_age_days: userAge,
      last_seen_at: Math.floor(Date.now() / 1000),
      hide_default_launcher: true
    });
  };
  
  /**
   * Opens Intercom with context-specific help
   * @param {string} topic - The help topic
   * @param {Object} contextData - Additional context data
   */
  export const openHelpWithContext = (topic, contextData = {}) => {
    if (typeof window === 'undefined' || !window.Intercom) return;
    
    // Registrar el evento de ayuda contextual
    window.Intercom('trackEvent', 'requested_help', {
      topic,
      ...contextData
    });
    
    // Abrir Intercom con un mensaje predefinido
    window.Intercom('showNewMessage', `Necesito ayuda con: ${topic}`);
  };